import style from "./../precision.module.css";
import { useSpring, animated } from "react-spring";
import { useInView } from "react-intersection-observer";
import { useTranslation } from "react-i18next";

const FalsePositivesChart = () => {
    const { t } = useTranslation("landing-page");
    
    const [ref, inView] = useInView({
        threshold: 0.5,
        triggerOnce: true,
    });

    // Animations for the correct bar
    const correctBarAnimation = useSpring({
        height: inView ? "199px" : "0px",
        from: { height: "0px" },
        config: { mass: 1, tension: 280, friction: 60 },
        delay: 300,
    });

    // Animation for the wrong bar
    const wrongBarAnimation = useSpring({
        height: inView ? "2px" : "0px",
        from: { height: "0px" },
        config: { mass: 1, tension: 280, friction: 60 },
        delay: 400,
    });

    // Animation for x-axis
    const xAxisAnimation = useSpring({
        width: inView ? "355px" : "0px",
        from: { width: "0px" },
        config: { mass: 1, tension: 280, friction: 60 },
        delay: 100,
    });

    // Animation for y-axis
    const yAxisAnimation = useSpring({
        height: inView ? "200px" : "0px",
        from: { height: "0px" },
        config: { mass: 1, tension: 280, friction: 60 },
        delay: 100,
    });

    return (
        <div ref={ref}>
            <div className={style.graphWrapper}>
                <p className={style.graphTitle}>{t("false_positives_chart.title")}</p>

                <animated.div className={style.yAxis} style={yAxisAnimation} />
                <animated.div className={style.xAxis} style={xAxisAnimation} />

                <animated.div className={style.correctBar} style={correctBarAnimation} />
                <animated.div className={style.wrongBar} style={wrongBarAnimation} />

                <p className={style.labelCorrect}>{t("false_positives_chart.recognized_as_original")}</p>
                <p className={style.labelWrong}>{t("false_positives_chart.incorrectly_recognized_as_ai")}</p>
            </div>
        </div>
    );
};

export default FalsePositivesChart;
